import React from 'react';
interface PercentFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
}
export function PercentField({
  label,
  value,
  onChange,
  placeholder = '0',
  required = false
}: PercentFieldProps) {
  const handleChange = (rawValue: string) => {
    const cleaned = rawValue.replace(/[^0-9.]/g, '');
    onChange(cleaned);
  };
  return <div className="flex flex-col gap-1" data-id="element-110">
      <label className="text-sm font-medium text-gray-700" data-id="element-111">
        {label}
        {required && <span className="text-red-500 ml-1" data-id="element-112">*</span>}
      </label>
      <div className="relative" data-id="element-113">
        <input type="text" value={value} onChange={e => handleChange(e.target.value)} placeholder={placeholder} required={required} className="w-full pr-7 pl-3 py-1.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent" data-id="element-114" />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500" data-id="element-115">
          %
        </span>
      </div>
    </div>;
}